export const sortByOptions = [
    { value: 'productiondate', label: 'Productiedatum' },
    { value: 'productnr', label: 'Productnr' },
    { value: 'ordernr', label: 'Ordernr' },
    { value: 'customer', label: 'Klant' },
    { value: 'reference', label: 'Referentie' },
    { value: 'ralnr', label: 'Ralnr' },
    { value: 'raltype', label: 'Raltype' },
    { value: 'poedernr', label: 'Poedernummer' },
    { value: 'deliverydate', label: 'Leveringsdatum' },
];

export const sortOrderOptions = [
    { value: 'ASC', label: 'Oplopend' },
    { value: 'DESC', label: 'Aflopend' },
];

export const sortEmptyOptions = [
    { value: 'ALL', label: 'Alle' },
    { value: 'NOT_EMPTY', label: 'Niet leeg' },
];

export const clearedFilters = {
    sortBy: sortByOptions[0].value,
    sortOrder: sortOrderOptions[0].value,
    sortEmpty: sortEmptyOptions[0].value,
    productNr: '',
    orderNr: '',
    customer: '',
    reference: '',
    ralNr: '',
    ralType: '',
    powderNr: '',
    productionDate: '',
    deliveryDate: '',
    productlistDefinitionKey: null,
    canvasType: '',
    canvasCode: '',
    canvasColor: '',
};
